@if (mapPositions()?.length && !trackplayService.loading && trackplayService.options) {
  <div class="wrapper">
    <mat-card appearance="outlined" class="p-4-8">
      <mat-card-content>
        <div class="container mb-26">
          <div class="box1 fs-10">
            <div class="d-flex justify-content-start align-items-center">
              <p for="fadeOutSelect">Fade out: &nbsp;</p>
              <select
                id="fadeOutSelect"
                [(ngModel)]="trackplayService.defaultConfig.fadeOutOption"
                (ngModelChange)="trackplayService.fadeOutRangeChange($event)"
              >
                @for (option of trackplayService.TIME_RANGE_OPTIONS; track option) {
                  <option [value]="option.value">{{ option.viewValue }}</option>
                }
              </select>
              <mat-icon
                [color]="trackplayService.defaultConfig.autoFocus ? 'accent' : ''"
                class="f-16 timeline-icon ml-12"
                [matTooltip]="
                  trackplayService.defaultConfig.autoFocus
                    ? 'Disable auto-focus'
                    : 'Enable auto-focus'
                "
                (click)="toggleAutoFocus()"
                >gps_fixed</mat-icon
              >
            </div>
          </div>
          <div class="box2">
            <div class="d-flex align-items-center">
              <div class="mr-6 d-flex">
                @if (trackplayService.startBtn !== trackplayService.REPLAY) {
                  <mat-icon
                    [matTooltip]="'Slow down'"
                    color="accent"
                    class="f-22"
                    (click)="trackplayService.slowForward()"
                    >fast_rewind</mat-icon
                  >
                }
              </div>
              <div class="mr-6 d-flex">
                <mat-icon
                  color="accent"
                  [class]="
                    trackplayService.getIcon() !== trackplayService.REPLAY
                      ? 'play-icon'
                      : 'refresh-icon'
                  "
                  [matTooltip]="'Play/Pause'"
                  (click)="
                    trackplayService.isProcessing ? null : trackplayService.togglePlayPause()
                  "
                >
                  {{ trackplayService.getIcon() }}
                </mat-icon>
              </div>
              <div class="mr-6 d-flex">
                @if (trackplayService.startBtn !== trackplayService.REPLAY) {
                  <mat-icon
                    [matTooltip]="'Speed up'"
                    color="accent"
                    class="f-16"
                    (click)="trackplayService.fastForward()"
                    >fast_forward</mat-icon
                  >
                }
              </div>
              <p matTooltip="Real-world time per second of animation" class="mr-6">
                speed:
                {{
                  trackplayService.TIME_SETTINGS[trackplayService.defaultConfig.speedIndex].label
                }}
              </p>
            </div>
          </div>
          <div class="box3">
            <mat-icon
              color="accent"
              class="f-22 close-icon"
              matTooltip="Close time slider"
              (click)="toggleBottomMenuVisibility()"
              >close</mat-icon
            >
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-center slider">
          <ngx-slider
            [value]="trackplayService.minValue"
            [highValue]="trackplayService.maxValue"
            [options]="trackplayService.options"
            (userChange)="trackplayService.onSliderChange($event)"
            (userChangeEnd)="trackplayService.onSliderChange($event)"
          ></ngx-slider>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}
